import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Alert: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58173 12.4183 0 8 0C3.58173 0 0 3.58173 0 8C0 12.4183 3.58173 16 8 16ZM8 3.57143C8.47338 3.57143 8.85714 3.95519 8.85714 4.42857V8.14286C8.85714 8.61624 8.47338 9 8 9C7.52662 9 7.14286 8.61624 7.14286 8.14286V4.42857C7.14286 3.95519 7.52662 3.57143 8 3.57143ZM9.14286 11.2857C9.14286 11.9169 8.63118 12.4286 8 12.4286C7.36882 12.4286 6.85714 11.9169 6.85714 11.2857C6.85714 10.6545 7.36882 10.1429 8 10.1429C8.63118 10.1429 9.14286 10.6545 9.14286 11.2857Z"
      fill="currentColor"
    />
  </svg>
);
